
import { useNavigate } from "react-router-dom";
import { BusinessCard, Business } from "./BusinessCard";

interface KoreanBusinessTabContentProps {
  businesses: Business[] | undefined;
  isLoading: boolean;
  handleBusinessClick: (id: string) => void;
}

export const KoreanBusinessTabContent = ({ 
  businesses, 
  isLoading, 
  handleBusinessClick 
}: KoreanBusinessTabContentProps) => {
  const navigate = useNavigate();
  
  if (isLoading) {
    return <div className="text-center py-8">로딩 중...</div>;
  }
  
  const filteredBusinesses = businesses?.filter(business => 
    !business.category.includes('과외') && 
    !business.category.includes('교육') && 
    !business.category.includes('부동산') &&
    !business.category.includes('변호사') &&
    !business.category.includes('오픈톡방') &&
    !business.category.includes('한인마트')
  );
  
  return (
    <>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mt-6">
        {filteredBusinesses?.map((business) => (
          <BusinessCard 
            key={business.id} 
            business={business} 
            onClick={() => handleBusinessClick(business.id)}
            hideImage={true}
          />
        ))}
      </div>
      {(!filteredBusinesses || filteredBusinesses.length === 0) && (
        <p className="text-center text-muted-foreground mt-4">더 많은 한인 업체가 곧 추가될 예정입니다.</p>
      )}
    </>
  );
};
